const copy = {
  waitingActions: {
    submitTicket: "Submit a ticket",
    receiveText: "Receive a text",
    callSupport: "Call support",
  },
  endedActions: {
    home: "Back to home screen",
    ticketDetails: "View ticket details",
    feedback: "Provide feedback on live chat",
  },
};

export default copy;
